export default async function getLoyalty({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'loyalty');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
